import type { CompanyDTO } from "@shaarp/common";

/**
 * The Google review count to show as a number, or null when it is only the
 * lower bound of a bucket (`reviewCountRange` set): the range label is shown
 * instead, never the bound as if it were exact.
 */
export function getExactGoogleReviewCount(
  google: Pick<CompanyDTO["reviews"]["google"], "review_count" | "reviewCountRange"> | undefined,
): number | null {
  if (google?.reviewCountRange) return null;
  return google?.review_count ?? 0;
}
